import React from 'react';
import { OrderFlowContext, OrderFlowContextProps } from '../context/OrderFlowContext';
import { OrderFlow } from '../types/order/orderFlow';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const orderFlowState = {
  items: new Map<string, OrderFlow>(),
  loading: false,
};

interface OrderFlowState {
  key: string;
}

export const orderFlowSlice = createSlice({
  name: 'orderFlow',
  initialState: { key: v4() } as OrderFlowState,
  reducers: {
    reset: state => {
      orderFlowState.items = new Map();
      orderFlowState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<OrderFlow[]>) => {
      orderFlowState.items = new Map();
      action.payload.forEach(of => orderFlowState.items.set(of.id, new OrderFlow(of)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<OrderFlow[]>) => {
      action.payload.forEach(of => orderFlowState.items.set(of.id, new OrderFlow(of)));
      orderFlowState.items = new Map(orderFlowState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<OrderFlow[]>) => {
      action.payload.forEach(of => orderFlowState.items.delete(of.id));
      orderFlowState.items = new Map(orderFlowState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      orderFlowState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface OrderFlowProviderProps {
  children: React.ReactNode;
}

export default function OrderFlowProvider({ children }: OrderFlowProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.orderFlows.key);

  const orderFlowContext: OrderFlowContextProps = {
    orderFlows: orderFlowState.items,
    orderFlowsLoading: orderFlowState.loading,
    setOrderFlows: (orderFlows: Map<string, OrderFlow>) => {
      dispatch(orderFlowSlice.actions.set([...orderFlows.values()]));
    },
  };

  return <OrderFlowContext.Provider value={orderFlowContext}>{children}</OrderFlowContext.Provider>;
}
